<template>
    <component :disabled="props.disabled" :is="props.as" :class="buttonClass">
        <icon v-if="props.leftIcon" :icon="props.leftIcon" :class="[
            'tw-text-xl',
            props.iconClass,
            props.loading && 'tw-invisible'
        ]" />

        <span v-if="!props.icon" class="tw-whitespace-normal" :class="[
            props.loading && 'tw-invisible'
        ]">
            <slot />
        </span>

        <icon v-if="props.icon" :icon="props.icon" :class="[
            'tw-text-xl',
            props.iconClass,
            props.loading && 'tw-invisible'
        ]" />

        <icon v-if="props.rightIcon" :icon="props.rightIcon" :class="[
            'tw-text-xl',
            props.iconClass,
            props.loading && 'tw-invisible'
        ]" />

        <icon v-if="props.loading" class="tw-absolute tw-text-xl" icon="line-md:loading-twotone-loop" />
    </component>
</template>
<script setup>
import { defineProps, computed } from 'vue';
import { cva } from 'class-variance-authority';

const props = defineProps({
    leftIcon: String,
    rightIcon: String,
    loading: Boolean,
    disabled: Boolean,
    full: Boolean,
    icon: String,
    iconClass: String,

    as: {
        type: [String, Object],
        default: 'button'
    },

    intent: {
        type: String,
        default: 'primary',
        validator: (v) => {
            return ['primary', 'secondary', 'danger', 'text', 'simple', 'info', 'warning', 'icon'].includes(v)
        }
    }
});

const buttonClass = computed(() => {
    return cva("tw-relative tw-inline-flex tw-w-fit tw-border tw-cursor-pointer active:tw-translate-y-0.5x active:tw-border-black/50 active:tw-shadow-none active:!tw-border-bx tw-border-solid tw-border-b-2 tw-items-center tw-justify-center tw-duration-200  tw-text-sm tw-rounded tw-min-h-[40px] tw-px-3 tw-py-0.5 tw-font-semibold tw-gap-2", 
    {
        variants: {
            intent: {
                primary: "tw-bg-primary-500 tw-text-white  tw-border-primary-600 hover:tw-bg-primary-400 hover:tw-border-primary-500",
                secondary: "tw-bg-primary-100 tw-text-primary-600  hover:tw-text-primary-700  tw-border-solid tw-border tw-border-primary-200",
                dark: "tw-bg-gray-100 tw-text-gray-600  tw-border-gray-200",
                danger: "tw-bg-rose-500 tw-text-white  tw-border-rose-600 hover:tw-bg-rose-400 hover:tw-border-rose-500",
                text: "tw-text-primary-500 tw-border-transparent hover:tw-border-primary-200",
                simple: "tw-text-neutral-700 hover:tw-text-primary-700 hover:tw-border-primary-400 tw-bg-white",
                warning: "tw-bg-amber-500 tw-text-white  !tw-border-amber-600",
                info: "tw-bg-cyan-500 tw-text-white  !tw-border-cyan-600",
                purple: "tw-bg-purple-500 tw-text-white  !tw-border-purple-600",
                icon: "tw-text-neutral-700 hover:tw-text-neutral-900 hover:tw-border-gray-300 tw-bg-white !tw-px-1.5 !tw-py-1.5 tw-min-h-[30px] tw-aspect-square",
            },
            disabled: {
                true: "!tw-bg-gray-100 !tw-text-gray-500  !tw-cursor-not-allowed !tw-border-gray-300 tw-opacity-75 !tw-shadow-none active:!tw-border-b-2 active:!tw-translate-y-0"
            },
            full: {
                true: "!tw-w-full"
            }
        }
    })({ intent: props.intent, disabled: props.disabled, full: props.full });
});

</script>
<style></style>